var wsUpdateUI = (message) => {

    const topBar = document.getElementById('topBar');
    const infoLevel = topBar.querySelector('#infoLevel');
    const infoCash = topBar.querySelector('#infoCash');
    const inboxLink = topBar.querySelector('#inboxLink');
    const inboxTag = inboxLink.querySelector('span');

    const currentCash = parseFloat(infoCash.textContent);
    const newCash = parseFloat(message.cash);
    const inboxCount = parseInt(message.inbox_count);

    const staticPath = document.getElementById('staticPath').textContent;

    if (currentCash !== newCash) {
        animateValueUpdate(infoCash, currentCash, newCash, 1500, `${staticPath}sound/gold.mp3`);
    }

    if (inboxCount > 0) {
        inboxTag.textContent = inboxCount;
        inboxTag.style.display = 'inline-flex';
    } else {
        inboxTag.style.display = 'none';
    }

    console.log(inboxCount);

    infoLevel.innerHTML = message.level;

}